     // Swym's wishlist count badge always renders, even at 0. Hide it when the
      // count is zero. Swym fills in the real count later by writing straight
      // into the existing text node (a characterData mutation, not a
      // childList one), so the observer has to watch both kinds or every
      // badge stays stuck at whatever it read on first paint.
      (function () {
        var COUNT = '.swym-advanced-wishlist-collections-social-count';

        function toggleCounts() {
          var counts = document.querySelectorAll(COUNT);

          for (var i = 0; i < counts.length; i++) {
            var count = counts[i];
            var value = parseInt(count.textContent, 10) || 0;
            count.style.display = value > 0 ? '' : 'none';
          }
        }

        var queued = false;

        function schedule() {
          if (queued) return;
          queued = true;
          requestAnimationFrame(function () {
            queued = false;
            toggleCounts();
          });
        }

        function start() {
          toggleCounts();

          new MutationObserver(function () {
            schedule();
          }).observe(document.body, {
            childList: true,
            subtree: true,
            characterData: true,
          });
        }

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', start);
        } else {
          start();
        }
      })();